$(window).ready(function () {

    $('.bg-envie-o-seu-tambem').click(function () {

        $(".enviar-background-content").fadeIn();

    });

    $('.enviar-background-content-close').click(function () {

        $(".enviar-background-content").fadeOut();

    });

});
